export const ENDUITS = [
  { key: "blanc_casse", label: "Blanc cassé", color: "#F2EDE3" },
  { key: "ton_pierre", label: "Ton pierre", color: "#D9C9A8" },
  { key: "gris_clair", label: "Gris clair", color: "#C8C7C2" },
  { key: "gris_moyen", label: "Gris moyen", color: "#8C8B86" },
  { key: "anthracite", label: "Anthracite", color: "#3A3A3A" },
  { key: "rouge_brique", label: "Rouge brique", color: "#9E3B2B" },
  { key: "vert_kaki", label: "Vert kaki", color: "#6B6B3A" },
];

export const DECO = [
  "Chaînes d'angle pierre de taille",
  "Contours fenêtres pierre",
  "Soubassement pierre",
  "Soubassement anthracite",
];

export const LIGHT = [
  "Spots LED façade",
  "LED entrée",
  "LED architectural",
];

export const slugify = (item) =>
  item
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")
    .substring(0, 40);
